"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M11 7.917c0 1.604-1.35 2.916-3 2.916S5 9.521 4.999 7.917c0-1.605 1.35-2.917 3-2.917s3 1.312 3 2.917zm8 0c0 1.604-1.35 2.916-3 2.916s-3-1.312-3-2.916C13 6.312 14.35 5 16 5s3 1.312 3 2.917zM8 12.972c-2.35 0-7 1.118-7 3.403V19h14.143v-2.625c0-2.285-4.793-3.403-7.143-3.403zm7.143.584c.35-.049.558-.049.857-.049 2.35 0 7 .583 7 2.868V19h-6.285v-2.625c0-1.458-.422-1.993-1.572-2.82z" }), "Friends");
//# sourceMappingURL=Friends.js.map